var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"homepage-hero-layout"},[_c('div',{staticClass:"hero-container",style:(_vm.heroBG)},[_c('HomepageLayout',[_vm._t("default")],2)],1),_vm._v(" "),_c('div',{staticClass:"below-hero"},[_vm._t("below-hero-content")],2),_vm._v(" "),(_vm.footer !== 'no')?_c('BottomNavigation'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f4b1ce2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/HomepageHeroLayout.vue
// module id = eRel
// module chunks = 1